// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-font[data-v-6f62c426]{font-size:.7em!important}.icon-wrapper[data-v-6f62c426] .v-input__append-inner,.v-autocomplete[data-v-6f62c426] .v-input__prepend-inner{-ms-flex-item-align:center;align-self:center;margin:0!important}", ""]);
// Exports
module.exports = exports;
